var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main pb-24 container mx-auto"},[_c('div',{staticClass:"w-full max-w-xs mx-auto"},[_c('h1',{staticClass:"text-center p-5 pt-10 md:pt-16"},[_vm._v(_vm._s(_vm.$t('LOGIN_LOG_IN')))]),_c('login-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }